import type { ChatMessage } from "@stockline/shared/types/ai/chat-message"
import type { OfflineResourceConfig } from "../../../types"
import { CHAT_MESSAGE_TABLE } from "./db"

export const chatMessageConfig: OfflineResourceConfig<ChatMessage> = {
  name: "chat-messages",
  // STK-1324: deferred, non-blocking -- hydrated via the SSE replay handshake
  // (cursor=0 full-table replay) AFTER readiness, not the cold-start waves.
  tier: "background",
  endpoints: {
    full: "/api/v2/chat-messages",
    delta: "/api/v2/chat-messages/changes",
    push: "/api/v2/chat-messages/changes",
  },
  tableName: CHAT_MESSAGE_TABLE,
  primaryKey: "id",
  indexes: {
    sessionId: "sessionId",
    companyId: "companyId",
    position: "position",
    status: "status",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
